import Vue from "vue";
import VueRouter from "vue-router";

import Nexus from "@/views/Nexus";
import Snitches from "@/views/Snitches";
import Captures from "@/views/Captures";
import Security from "../views/Security.vue";
import MasterMonitor from "../views/MasterMonitor.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "MasterMonitor",
    component: MasterMonitor,
  },
  {
    path: "/snitches",
    name: "Snitches",
    component: Snitches,
  },
  {
    path: "/nexus",
    name: "Nexus",
    component: Nexus,
  },
  {
    path: "/screen-snitch",
    name: "Captures",
    component: Captures,
  },
  {
    path: "/security",
    name: "Security",
    component: Security,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
